import * as React from 'react';
export const kredivoSvg = React.forwardRef(function kredivoSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M18.252 26.336c-1.935-2.176-3.185-3.561-3.566-3.957-.338-.352-.444-.536-.45-.787 0-.106.006-.144.035-.202.038-.082-.01-.034 1.331-1.434.565-.588 1.1-1.148 1.188-1.24.448-.473.492-.511.598-.57.265-.14.497-.149.729-.033.13.068.01-.063 1.592 1.675.637.7 1.733 1.906 2.437 2.678 1.37 1.505 2.48 2.731 2.703 2.982.212.241.28.41.275.724 0 .294-.082.492-.251.618-.15.11.106.101-3.17.101h-2.964l-.487-.555Z',
      fill: '#48BBE5',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6.44 26.741c-.044-.01-.102-.033-.136-.043a.63.63 0 0 1-.26-.265L6 26.34v-6.456l6.751-7.383 6.752-7.384 2.92-.005c2.87-.004 2.919-.004 3.02.024.222.068.41.227.502.415a.483.483 0 0 1 .053.232.801.801 0 0 1-.097.444c-.086.183-.173.294-.492.632-.781.825-3.098 3.35-10.612 11.539-5.433 5.926-7.205 7.851-7.431 8.083a1.01 1.01 0 0 1-.415.236 1.16 1.16 0 0 1-.512.024Z',
      fill: '#F37D31',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6.526 16.226a.7.7 0 0 1-.444-.376l-.058-.12-.005-5.082c-.004-5.7-.014-5.178.116-5.318a.606.606 0 0 1 .328-.184c.097-.024.266-.029 2.288-.029s2.19 0 2.282.03a.604.604 0 0 1 .459.468c.02.082.024.42.024 2.92v2.827l-.598.661c-2.191 2.442-3.509 3.875-3.692 4.025-.203.169-.478.241-.7.178Z',
      fill: '#48BBE5',
    }),
  );
});
kredivoSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var kredivo = {
  category: 'brand',
  colorable: false,
  name: 'kredivo',
  svg: kredivoSvg,
};
